module.exports = __webpack_public_path__ + "img/backyard-side-door.60a484e0.webp";